import { ObjectFactory } from '@/config/objectFactory';
import { RxProvider } from '@/types/entity';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IRxProviderService } from '../iRxProviderService';

export class RxProviderService implements IRxProviderService {
    public async getRxProviders(baseURL: string, searchString?: string, start?: number, limit?: number):
    Promise<ApiResponse<RxProvider[]>> {
    const iHttpService = ObjectFactory.getHttpService();
    const queryRecordsRequest: QueryRecordsRequest = {
        limit: limit ? limit : MedTransGoConstants.PAGINATION_LIMIT,
        start,
    };
    const apiRequest: ApiRequest = {
        baseURL,
        data: queryRecordsRequest,
        url: `${MedTransGoConstants.HTTP_URL_RXPROVIDERS}/list`,
        loaderEvent: {
            show: true,
        },
    };
    const response = await iHttpService.post<RxProvider[]>(apiRequest);
    if (!response.success) {
        CommonUtils.showError(response);
    }
    return response;
}

public async getRxProviderDetails(baseURL: string, rxproviderId: string):
Promise<ApiResponse<any>> {
    const iHttpService = ObjectFactory.getHttpService();
    const apiRequest: ApiRequest = {
        baseURL,
        url: `${MedTransGoConstants.HTTP_URL_RXPROVIDERS}/${rxproviderId}`,
        loaderEvent: {
            show: true,
        },
    };
    const response = await iHttpService.get<RxProvider>(apiRequest);
    if (!response.success) {
        CommonUtils.showError(response);
    }
    return response;
}

public async updateRxProvider(baseURL: string, rxproviderId: string, updateRxProviderRequest: RxProvider):
Promise<ApiResponse<any>> {
    const iHttpService = ObjectFactory.getHttpService();
    const apiRequest: ApiRequest = {
        baseURL,
        data: updateRxProviderRequest,
        url: `${MedTransGoConstants.HTTP_URL_RXPROVIDERS}/${rxproviderId}`,
    };
    const response = await iHttpService.put<any>(apiRequest);
    if (!response.success) {
        CommonUtils.showError(response);
    }
    return response;
}

public async addRxProvider(baseURL: string, addRxProviderRequest: RxProvider): Promise<ApiResponse<any>> {
    const iHttpService = ObjectFactory.getHttpService();
    const apiRequest: ApiRequest = {
        baseURL,
        url: `${MedTransGoConstants.HTTP_URL_RXPROVIDERS}`,
        data: addRxProviderRequest,
        loaderEvent: {
            show: true,
        },
      };
    const response = await iHttpService.post <RxProvider>(apiRequest);
    if (!response.success) {
        CommonUtils.showError(response);
    }
    return response;
}

}
